import { Storage } from '@ionic/storage';
import { 
  KEY_AZURE_TOKEN, 
  KEY_ACCESS_TOKEN, 
  KEY_REFRESH_TOKEN 
} from '../Helpers/constant';

// Initialize Ionic Storage. `create()` is async (IndexedDB driver init) — every
// read/write below awaits this same promise so callers never race an
// unfinished init (was previously fire-and-forget, causing intermittent
// empty reads on fresh page loads/refreshes).
const storage = new Storage();
const storageReady: Promise<Storage> = storage.create();

// Storage service class
class StorageService {
  private storageReady: Promise<Storage>;

  constructor() {
    this.storageReady = storageReady;
  }

  // Set item in storage
  async setItem(key: string, value: any): Promise<void> {
    try {
      const store = await this.storageReady;
      await store.set(key, value);
    } catch (error) {
      console.error('Error setting item in storage:', error);
      throw error;
    }
  }

  // Get item from storage
  async getItem(key: string): Promise<any> {
    try {
      const store = await this.storageReady;
      const value = await store.get(key);
      return value;
    } catch (error) {
      console.error('Error getting item from storage:', error);
      throw error;
    }
  }

  // Remove item from storage
  async removeItem(key: string): Promise<void> {
    try {
      const store = await this.storageReady;
      await store.remove(key);
    } catch (error) {
      console.error('Error removing item from storage:', error);
      throw error;
    }
  }

  // Clear all storage
  async clear(): Promise<void> {
    try {
      const store = await this.storageReady;
      await store.clear();
    } catch (error) {
      console.error('Error clearing storage:', error);
      throw error;
    }
  }

  // Get all keys
  async keys(): Promise<string[]> {
    try {
      const store = await this.storageReady;
      return await store.keys();
    } catch (error) {
      console.error('Error getting storage keys:', error);
      throw error;
    }
  }

  // Check if key exists
  async hasKey(key: string): Promise<boolean> {
    try {
      const store = await this.storageReady;
      const value = await store.get(key);
      return value !== null && value !== undefined;
    } catch (error) {
      console.error('Error checking key in storage:', error);
      throw error;
    }
  }
}

// Create and export a singleton instance
const storageService = new StorageService();

export default storageService; 